import { Transforms } from "slate";
import { ReactEditor, RenderElementProps, RenderLeafProps, useSlate } from "slate-react";
import { Trash } from 'react-bootstrap-icons'
import { IconButton } from "../widgets/IconButton";
import { Property } from 'csstype'
import React from "react";

/**
 * translates the slate json representation into a form that is renderable in the text view area
 * Note that this is similar, but not the same as the exhibit.body html representation presisted
 * to the server. <- the job of the serializer
 * @param param0 
 * @returns 
 */
export const RenderLeaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  if (leaf.superscript) {
    children = <sup>{children}</sup>;
  }
  if (leaf.subscript) {
    children = <sub>{children}</sub>;
  }

  return (
    <span
      {...attributes}
      style={{
        ...(leaf.bold && { fontWeight: "bold" }),
        ...(leaf.italic && { fontStyle: "italic" }),
        ...(leaf.underline && { textDecoration: "underline" }),
        ...(leaf.strikethrough && { textDecoration: "line-through" }),
        ...(leaf.code && {
          color: "black",
          padding: 2,
          fontSize: 12,
          fontFamily: "monospace",
          background: "#eee",
        }),
        ...(leaf.highlight && {
          color: "black",
          padding: 2,
          background: "#f3ff63",
          border: "1px solid #c6c202",
        }),
      }}
    >
      {children}
    </span>
  );
};

export const RenderElement = ({
  attributes,
  children,
  element,
}: RenderElementProps) => {

  // we are in render already, which will impart a change, so useSlateStatic seems sensible here.
  const editor = useSlate()
  const path = ReactEditor.findPath(editor, element)
  const style = { textAlign: element.align as Property.TextAlign };
  switch (element.type) {
    case "block-quote": {
      return (
        <blockquote
          style={{
            ...style,
            borderLeft: "2px solid #ddd",
            paddingLeft: 10,
            color: "#aaa",
            fontStyle: "italic",
          }}
          {...attributes}
        >
          {children}
        </blockquote>
      );
    }
    case "numbered-list": {
      return (
        <ol style={style} {...attributes}>
          {children}
        </ol>
      );
    }
    case "bulleted-list": {
      return (
        <ul style={style} {...attributes}>
          {children}
        </ul>
      );
    }
    case "list-item": {
      return (
        <li style={style} {...attributes}>
          {children}
        </li>
      );
    }
    case "h1": {
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      );
    }
    case "h2": {
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      );
    }
    case "h3": {
      return (
        <h3 style={style} {...attributes}>
          {children}
        </h3>
      );
    }
    case "h4": {
      return (
        <h4 style={style} {...attributes}>
          {children}
        </h4>
      );
    }
    case "h5": {
      return (
        <h5 style={style} {...attributes}>
          {children}
        </h5>
      );
    }
    case "h6": {
      return (
        <h6 style={style} {...attributes}>
          {children}
        </h6>
      );
    }
    case "image": {
      console.log('its the Slatester, doing the render')
      console.log(path)
      return (
        <div {...attributes}>
          <div contentEditable={false} style={{position: 'relative'}}>
            <img style={style} alt='' src={element.url} {...attributes} />
            <IconButton
              w='25px'
              h='25px'
              bColor='#999'
              bRad='4px'
              p='2px'
              m='2px'
              label='delete image'
              icon={<Trash/>}
              onClick={() => {
                Transforms.removeNodes(editor, { at: path })
                console.log('hit me')
              }}
            />
          </div>
        </div>
      );
    }
    case 'link': {
      return (
        <span {...attributes}>
          <span contentEditable={false} style={{position: 'relative'}}>
            <a style={style} href={element.url} target={element.target} {...attributes} >
              {children}
            </a>
            <IconButton
              w='25px'
              h='25px'
              bColor='#999'
              bRad='4px'
              p='2px'
              m='2px'
              label='delete link'
              icon={<Trash/>}
              onClick={() => {
                Transforms.removeNodes(editor, { at: path })
                console.log('hit me')
              }}
            />
          </span>
        </span>
      );
    }
    default: {
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
    }
  }
};
